"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var react_calendar_timeline_1 = require("react-calendar-timeline");
var LocaleProvider_1 = __importDefault(require("../../LocaleProvider"));
var CalendarHeader = /** @class */ (function (_super) {
    __extends(CalendarHeader, _super);
    function CalendarHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.now = new Date();
        _this.localeChanged = function () {
            _this.forceUpdate();
        };
        _this.labelFormat = function (_a, unit, labelWidth) {
            var startTime = _a[0], endTime = _a[1];
            var day = startTime.day();
            var month = startTime.month();
            var year = startTime.year();
            var week = startTime.week();
            var active = startTime.isSame(moment_1.default(_this.now), "day");
            if (unit === "day") {
                return (react_1.default.createElement("span", { className: "day" + (active ? " active" : "") },
                    react_1.default.createElement("span", { className: "date" }, startTime.format("D")),
                    " ",
                    react_1.default.createElement("span", { className: "dayName" }, LocaleProvider_1.default.locs.date_picker.strings.weekdaysShort[day])));
            }
            if (unit === "month") {
                if (labelWidth > 400) {
                    return LocaleProvider_1.default.locs.date_picker.strings.months[month] + " " + startTime.format("YYYY");
                }
                else if (labelWidth > 100) {
                    return LocaleProvider_1.default.locs.date_picker.strings.months[month];
                }
                else {
                    return LocaleProvider_1.default.locs.date_picker.strings.shortMonths[month];
                }
            }
            if (unit === "year") {
                return "" + year;
            }
            if (unit === "week") {
                return week + ". " + LocaleProvider_1.default.locs.date_picker.strings.week + " - " + LocaleProvider_1.default.locs.date_picker.strings.months[month] + " " + year;
            }
            // We dont need other units
            return "";
        };
        return _this;
    }
    CalendarHeader.prototype.componentDidMount = function () {
        LocaleProvider_1.default.on(this.localeChanged);
    };
    CalendarHeader.prototype.componentWillUnmount = function () {
        LocaleProvider_1.default.off(this.localeChanged);
    };
    CalendarHeader.prototype.render = function () {
        return react_1.default.createElement(react_calendar_timeline_1.DateHeader, __assign({}, this.props, { labelFormat: this.labelFormat, height: 40 }));
    };
    return CalendarHeader;
}(react_1.default.PureComponent));
exports.default = CalendarHeader;
//# sourceMappingURL=index.js.map